import { appConfigSignal, appConfigLoadedSignal, appConfigErrorSignal } from '../signals/appConfigSignals.js'

/****************************************************************************
 * 
 * Application config
 * 
 ***************************************************************************/

export const fetchAppConfig = async () => {
    appConfigLoadedSignal.value = false
    appConfigSignal.value = null
    const url = '/config.json'
    return await fetch(url).then(
        async (response) => {
            return await response.json().then(
                (result) => {
                    appConfigErrorSignal.value = null
                    appConfigSignal.value = result
                    appConfigLoadedSignal.value = true
                    return result
                }
            )
        }
    ).catch(
        (error) => {
            appConfigErrorSignal.value = error
            appConfigSignal.value = null
        }
    )
}